// extracted by mini-css-extract-plugin
export default {"link":"style_link__rg+jQ","img":"style_img__sSNit"};